import { Typography } from '@mui/material';
import type { MouseEventHandler, PropsWithChildren } from 'react';
import React from 'react';
import styled from 'styled-components';

import { heading } from '@constants/fonts';

export const TitleH2: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography color="primary.main" variant="subtitle2">
      {children}
    </Typography>
  );
};

export const InfoH2: React.FC<
  PropsWithChildren<{ clickable?: boolean; onClick?: MouseEventHandler }>
> = ({ children, clickable }) => {
  return (
    <Typography
      color="text.primary"
      variant="body1"
      sx={{
        cursor: clickable ? 'pointer' : 'unset',
      }}
    >
      {children}
    </Typography>
  );
};

export const SectionH2 = styled.div`
  padding: 5px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider}99;
  font-weight: 500;
  width: 100%;
  text-transform: uppercase;
  font-family: ${heading};
  font-size: 14px;
  letter-spacing: 0.3px;
`;

export const CommonCard = styled.div`
  padding: 20px;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 15px;

  ${(props) => props.theme.breakpoints.down('lg')} {
    width: 100% !important;
    margin-bottom: 10px;
  }
`;
